import { Component, OnInit } from '@angular/core';
import { AppService } from 'app/app.service';
import { Router } from '@angular/router';
import { fadeInSlideAnimation } from 'animations';
import { RemoteServicesProvider } from 'providers/remote-services/remote-services';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { TranslationProvider } from 'providers/translation/translation';
import * as _ from 'lodash';
import { SpotData } from 'dto';

@Component({
    selector: 'app-newspot-survey',
    templateUrl: './newspot-survey.component.html',
    styleUrls: ['./newspot-survey.component.scss'],

    animations: [fadeInSlideAnimation],
    host: { '[@fadeInSlideAnimation]': '' }
})
export class NewspotSurveyComponent implements OnInit {

    inputData = null;
    domainData = null;
    spotData: SpotData = null;

    constructor(
        private appService: AppService,
        private router: Router,
        public remoteService: RemoteServicesProvider,
        private domainStorageProvider: DomainStorageProvider,
        public translationProvider: TranslationProvider,
    ) {
        this.showHideMenu(false);

        this.spotData = this.domainStorageProvider.rootStore.spotData.value;
        if (!this.spotData) {
            this.router.navigate(["/searchpos"]);
        }

        this.inputData = this.spotData && this.spotData.notes ? this.spotData.notes : {};
        this.domainData = this.domainStorageProvider.rootStore.survey;
        this.domainData.forEach(question => {
            if ((question.typeId === 0 || question.typeId === 2) && !this.inputData[question.id]) {
                this.inputData[question.id] = {};
            }
        });
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    back() {
        this.router.navigate(["/newspot"]);
    }

    submitSurvey() {
        let spotData = this.domainStorageProvider.rootStore.spotData.value;
        spotData.setNotes(this.sanitizeData());
        this.router.navigate(["/newspot"]);
    }

    sanitizeData() {
        let dataResult = {};
        _.each(this.inputData, (element, key) => {
            if (Array.isArray(element)) {
                if (element.length > 0) {
                    dataResult[key] = element;
                }
            } else if (typeof element === "string") {
                if (element.replace(/\s/g, "").length > 0) {
                    dataResult[key] = element;
                }
            } else if (typeof element === "object") {
                if (Object.keys(element).length > 0) {
                    let shouldAdd = false;
                    let objResult = {};
                    for (var keyLoop in element) {
                        // check also if property is not inherited from prototype
                        if (element.hasOwnProperty(keyLoop) && element[keyLoop] == true) {
                            objResult[keyLoop] = true;
                            shouldAdd = true;
                        }
                        if (shouldAdd) {
                            dataResult[key] = objResult;
                        }
                    }
                }
            } else {
                dataResult[key] = element;
            }
        });
        return dataResult;
    }
}
